module.exports = __webpack_public_path__ + "completed.93ecf929.svg";